import React, { ReactNode, useContext } from "react";
import { ResultsContext } from "@state/context/results";
import { tbodyColspanMax } from "./utils";
import OfferIcon from "@components/icons/Offer";

export default function ResultsTableHeader({
	children,
}: {
	children?: ReactNode;
}) {
	const result = useContext(ResultsContext);

	return (
		<thead className="table--results__header">
			<tr className="table--results__header__row">
				<th
					className="table--results__header__data u-type--left"
					colSpan={children ? tbodyColspanMax : tbodyColspanMax + 1}
				>
					<OfferIcon
						type="sport"
						sport={result.sport.abrv}
						className="u-icon u-icon--sml u-align--v--middle u-mar--right--xtny"
					/>
					<span className="u-align--v--middle">
						{result.sport.name} - {result.sportCategory.name}
					</span>
				</th>

				{children}
			</tr>
		</thead>
	);
}
